<assessment-row title="Line">
  <div class="container">
    <emr-input class="section" type="text" width="65%" placeholder="Description"
      [control]="formGroup().controls.lineDescription" />
    <div class="flex-row">
      <div class="flex-one">
        <span class="intake-output">Intake</span>
        <emr-input type="text" width="30%" [control]="formGroup().controls.lineIntake" />
      </div>
      <div class="flex-one">
        <span class="intake-output width-70">Output</span>
        <emr-input type="text" width="30%" [control]="formGroup().controls.lineOutput" />
      </div>
    </div>
  </div>
</assessment-row>

<assessment-row title="Tube">
  <div class="container">
    <emr-input class="section" type="text" width="65%" placeholder="Description"
      [control]="formGroup().controls.tubeDescription" />
    <div class="flex-row">
      <div class="flex-one">
        <span class="intake-output">Intake</span>
        <emr-input type="text" width="30%" title="Intake" [control]="formGroup().controls.tubeIntake" />
      </div>
      <div class="flex-one">
        <span class="intake-output width-70">Output</span>
        <emr-input type="text" width="30%" title="Output" [control]="formGroup().controls.tubeOutput" />
      </div>
    </div>
  </div>
</assessment-row>

<assessment-row title="Airway">
  <div class="container">
    <emr-input class="section" type="text" width="65%" placeholder="Description"
      [control]="formGroup().controls.airwayDescription" />
  </div>
</assessment-row>

<assessment-row title="Drain">
  <div class="container">
    <emr-input class="section" type="text" width="65%" placeholder="Description"
      [control]="formGroup().controls.drainDescription" />
    <div class="flex-row">
      <div class="flex-one">
        <span class="intake-output">Intake</span>
        <emr-input type="text" width="30%" title="Intake" [control]="formGroup().controls.drainIntake" />
      </div>
      <div class="flex-one">
        <span class="intake-output width-70">Output</span>
        <emr-input type="text" width="30%" title="Output" [control]="formGroup().controls.drainOutput" />
      </div>
    </div>
  </div>
</assessment-row>

<assessment-row title="Oral">
  <div class="container">
    <emr-input class="section" type="text" width="65%" placeholder="Description"
      [control]="formGroup().controls.oralDescription" />
    <div class="flex-row">
      <div class="flex-one">
        <span class="intake-output">Intake</span>
        <emr-input type="text" width="30%" title="Intake" [control]="formGroup().controls.oralIntake" />
      </div>
      <div class="flex-one">
        <span class="intake-output width-70">Emesis</span>
        <emr-input type="text" width="30%" title="Emesis" [control]="formGroup().controls.oralEmesis" />
      </div>
    </div>
  </div>
</assessment-row>

<assessment-row title="Stool">
  <div class="container">
    <emr-input class="section" type="text" width="65%" placeholder="Description"
      [control]="formGroup().controls.stoolDescription" />
    <div class="flex-row">
      <div class="flex-one">
        <span class="intake-output width-70">Output</span>
        <emr-input type="text" width="30%" title="Output" [control]="formGroup().controls.stoolOutput" />
      </div>
    </div>
  </div>
</assessment-row>

@if (patient().isPediatric()) {
  <assessment-row title="Infant Nutrition">
    <emr-checkbox [control]="formGroup().controls.infantNutrition" label="Yes" />
  </assessment-row>

  @if (isInfantNutrition) {
    <assessment-row title="Breastfeeding">
      <emr-checkbox [control]="formGroup().controls.breastfeeding" label="Yes" />
    </assessment-row>

    @if (isBreastfeeding) {
      <assessment-row title="Feeding Occurrence">
        <emr-input type="text" [control]="formGroup().controls.feedingOccurrence" /> 
      </assessment-row>

      <assessment-row title="LATCH Scale">
        <div class="latch-scale-container">
          <div class="latch-scale-row">
            <span class="latch-scale-label">Latch</span>
            <emr-input type="select" [control]="formGroup().controls.LSlatch" [options]="latchOptions" />
          </div>
          <div class="latch-scale-row">
            <span class="latch-scale-label">Audible</span>
            <emr-input type="select" [control]="formGroup().controls.LSaudible" [options]="audibleOptions" />
          </div>
          <div class="latch-scale-row">
            <span class="latch-scale-label">Type</span>
            <emr-input type="select" [control]="formGroup().controls.LStype" [options]="typeOptions" />
          </div>
          <div class="latch-scale-row">
            <span class="latch-scale-label">Comfort</span>
            <emr-input type="select" [control]="formGroup().controls.LScomfort" [options]="comfortOptions" />
          </div>
          <div class="latch-scale-row">
            <span class="latch-scale-label">Hold</span>
            <emr-input type="select" [control]="formGroup().controls.LShold" [options]="holdOptions" />
          </div>
        </div>
      </assessment-row>

      
      <assessment-row title="LATCH Score">
        <h3 class="ls-score">{{ computeLSScore() }}</h3>
      </assessment-row>
    }

    <assessment-row title="Bottlefeeding">
      <emr-checkbox [control]="formGroup().controls.bottlefeeding" label="Yes" />
    </assessment-row>

    @if (isBottlefeeding) {
      <assessment-row title="Feeding Tolerance">
        <emr-input type="text" [control]="formGroup().controls.feedingTolerance" /> 
      </assessment-row>

      <assessment-row title="Formula">
        <emr-input type="text" [control]="formGroup().controls.formula" /> 
      </assessment-row>

      <assessment-row title="Number of Ounces">
        <emr-input type="text" [control]="formGroup().controls.numOfOunces" /> 
      </assessment-row>
    }
  } <!-- end infantNutrition -->
} <!-- end patient().isPediatric() -->
